import { useCoreContext } from '@/core';
import { CourseTopicEntity } from '@/domains/course-topic/entities';
import { Button, Form, Input, Spin, Switch } from 'antd';
import React, { useEffect } from 'react';
import { CourseTopicFormViewModel } from '../../viewmodels';

interface Props {
  detailCourseTopic: CourseTopicEntity;
  openForm: boolean;
  onFormSubmitSuccess?: () => void;
}

export const CourseTopicForm = (props: Props) => {
  const { detailCourseTopic, openForm, onFormSubmitSuccess } = props;
  const { loading } = useCoreContext();
  const [form] = Form.useForm();
  const { actionSaveCourseTopic, validateForm } = CourseTopicFormViewModel();
  const { schemaCourseTopic } = validateForm({ detailCourseTopic });

  useEffect(() => {
    if (detailCourseTopic && detailCourseTopic.id) {
      form.setFieldsValue({
        id: detailCourseTopic.id,
        name: detailCourseTopic.name,
        description: detailCourseTopic.description,
        isActive: detailCourseTopic.isActive,
      });
    } else {
      form.resetFields();
    }
  }, [detailCourseTopic, form, openForm]);

  const onFinish = async (values: any) => {
    const success = await actionSaveCourseTopic({
      id: detailCourseTopic?.id,
      ...values,
    });

    if (success) {
      // Reset form after successful submission
      form.resetFields();

      // Notify parent component about successful submission
      if (onFormSubmitSuccess) {
        onFormSubmitSuccess();
      }
    }
  };

  if (loading) {
    return <Spin />;
  }

  return (
    <Form
      form={form}
      name='course-topic-form'
      onFinish={onFinish}
      layout='vertical'
      initialValues={{ isActive: true }}
    >
      <Form.Item
        name='name'
        label='Name'
        rules={[{ required: true, message: 'Please input the name!' }]}
      >
        <Input placeholder='Enter name' />
      </Form.Item>
      <Form.Item
        name='description'
        label='Description'
        rules={[{ required: true, message: 'Please input the description!' }]}
      >
        <Input.TextArea rows={4} placeholder='Enter description' />
      </Form.Item>
      <Form.Item name='isActive' label='Status' valuePropName='checked'>
        <Switch checkedChildren='Active' unCheckedChildren='Inactive' />
      </Form.Item>
      <Form.Item name='isActive' label='Status' valuePropName='checked'>
        <Switch checkedChildren='Active' unCheckedChildren='Inactive' />
      </Form.Item>
      <Form.Item>
        <Button type='primary' htmlType='submit'>
          {detailCourseTopic?.id ? 'Update' : 'Create'}
        </Button>
      </Form.Item>
    </Form>
  );
};
